import { getQueryStringParameter } from '../../../helpers';
import { addSupplementalDoc } from '../documents_step';

$(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'documents') {
    return;
  }

  addSupplementalDoc($form);
});
